import React from 'react';

export default (_props) => {
  const { className, size, large, small, ...props } = _props;

  // small icon
  if ((size && size.toLowerCase() === 'small') || small) {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" className={`audiicon audiicon-small ${className ? className : ''}`} {...props}>
        <g stroke="currentColor" strokeWidth="1" fill="none" fillRule="evenodd">
          <path d="M3.5,15.5 C5.7,19.9 11.1,21.7 15.6,19.5 C20.1,17.3 21.8,11.9 19.6,7.4 C18.1,4.3 15,2.4 11.5,2.4 C7.2,2.4 4.1,5.9 3.2,9.4"/>
          <path d="M9.5 9.5L2.5 9.5 2.5 2.5"/>
        </g>
      </svg>
    );
  }

  // large icon
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" className={`audiicon audiicon-large ${className ? className : ''}`} {...props}>
      <g stroke="currentColor" strokeWidth="1" fill="none" fillRule="evenodd">
        <path d="M9.3,30.8 C13.3,38.7 23,41.8 30.8,37.7 C38.6,33.6 41.8,24 37.7,16.2 C35,10.9 29.5,7.5 23.5,7.5 C17.1,7.5 11.4,11.5 9.1,17.5"/>
        <path d="M18 17.5L8.5 17.5 8.5 8"/>
      </g>
    </svg>
  );
};
